const beneficiariesData = [
  {
    userId: "USR-001",
    userName: "Alex Johnson",
    beneficiaryId: "BNF-8829",
    beneficiaryName: "Quantum Solutions Ltd",
    receiverType: "Organization",
    receivingMethod: "Bank transfer",
    phone: "+65 8823 1234",
    createdTime: "11/03/2026 10:45:13",
    country: "Philippines",
    currency: "Philippine Peso",
    relationship: "Business partner",
    idType: "Business License",
    idNumber: "REG-99281-X",
    idExpiryDate: "20/12/2030",
    dob: "12/05/1985",
    firstName: "Quantum",
    middleName: "Global",
    lastName: "Solutions",
    middleInitial: "Q",
    jointAccountHolder: "-",
    taxId: "TAX-8827-11",
    companyReg: "LC-99281",
    nativeName: "クォンタム",
    contactNumber: "+65 8823 1234",
    address: "1080 Hefenstrate",
    city: "Helgoland",
    state: "12365",
    postalCode: "55432",
    suburb: "Northern District",
    bank: "BANK OF CHINA",
    cashPickupLocation: "-",
    iban: "CH88 0012 3344 5566 77",
    accountNumber: "05520000003601",
    accountType: "Corporate Savings",
    bankAccountTitle: "Quantum Solutions Ltd Operating",
    transitNumber: "123",
    sortCode: "88-22-11",
    routingNumber: "021000021",
    bsbNumber: "062-000",
    branchName: "Central Branch",
    branchCode: "BCH-001",
    branchNumber: "442",
    ifscNumber: "BKCH0001234",
    swiftCode: "BKCHCNBJ",
    institutionNumber: "001",
  },
  {
    userId: "USR-042",
    userName: "Maria Garcia",
    beneficiaryId: "BNF-7712",
    beneficiaryName: "Sarah Williams",
    receiverType: "Individual",
    receivingMethod: "Cash pickup",
    phone: "+63 917 123 4567",
    createdTime: "11/03/2026 09:31:58",
    country: "Philippines",
    currency: "Philippine Peso",
    relationship: "Family",
    idType: "Passport",
    idNumber: "P-8827361",
    idExpiryDate: "15/05/2028",
    dob: "04/03/2000",
    firstName: "Sarah",
    middleName: "Jane",
    lastName: "Williams",
    middleInitial: "S",
    jointAccountHolder: "-",
    taxId: "-",
    companyReg: "-",
    nativeName: "Sarah",
    contactNumber: "+63 917 123 4567",
    address: "742 Evergreen Terrace",
    city: "Manila",
    state: "Metro Manila",
    postalCode: "1001",
    suburb: "Makati",
    bank: "BDO Unibank",
    cashPickupLocation: "Cebuana Lhuillier - Makati Ave",
    iban: "-",
    accountNumber: "1029384756",
    accountType: "Personal",
    bankAccountTitle: "Sarah Jane Williams",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Makati Main",
    branchCode: "MKT-882",
    branchNumber: "05",
    ifscNumber: "-",
    swiftCode: "BNORPHMM",
    institutionNumber: "-",
  },
  {
    userId: "USR-015",
    userName: "James Tan",
    beneficiaryId: "BNF-3341",
    beneficiaryName: "PT Maju Bersama",
    receiverType: "Organization",
    receivingMethod: "Bank transfer",
    phone: "+62 812 3456 7890",
    createdTime: "10/03/2026 14:22:05",
    country: "Indonesia",
    currency: "Indonesian Rupiah",
    relationship: "Business partner",
    idType: "Business License",
    idNumber: "NIB-1234567890",
    idExpiryDate: "30/06/2029",
    dob: "08/11/1979",
    firstName: "PT",
    middleName: "Maju",
    lastName: "Bersama",
    middleInitial: "M",
    jointAccountHolder: "-",
    taxId: "NPWP-09.876.543.2-001",
    companyReg: "AHU-0012345",
    nativeName: "PT Maju Bersama",
    contactNumber: "+62 812 3456 7890",
    address: "Jl. Sudirman No. 88",
    city: "Jakarta",
    state: "DKI Jakarta",
    postalCode: "10220",
    suburb: "Senayan",
    bank: "Bank Mandiri",
    cashPickupLocation: "-",
    iban: "-",
    accountNumber: "1230005678901",
    accountType: "Corporate Current",
    bankAccountTitle: "PT Maju Bersama Operasional",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Sudirman Branch",
    branchCode: "SDR-007",
    branchNumber: "007",
    ifscNumber: "-",
    swiftCode: "BMRIIDJA",
    institutionNumber: "-",
  },
  {
    userId: "USR-088",
    userName: "Chen Wei",
    beneficiaryId: "BNF-5503",
    beneficiaryName: "Li Mei",
    receiverType: "Individual",
    receivingMethod: "Bank transfer",
    phone: "+86 138 0013 8000",
    createdTime: "10/03/2026 11:05:47",
    country: "China",
    currency: "Chinese Yuan",
    relationship: "Friend",
    idType: "National ID",
    idNumber: "110101199003072518",
    idExpiryDate: "01/01/2035",
    dob: "07/03/1990",
    firstName: "Mei",
    middleName: "-",
    lastName: "Li",
    middleInitial: "-",
    jointAccountHolder: "-",
    taxId: "-",
    companyReg: "-",
    nativeName: "李梅",
    contactNumber: "+86 138 0013 8000",
    address: "88 Wangfujing Street",
    city: "Beijing",
    state: "Beijing",
    postalCode: "100006",
    suburb: "Dongcheng",
    bank: "Industrial and Commercial Bank of China",
    cashPickupLocation: "-",
    iban: "-",
    accountNumber: "6222021001122334455",
    accountType: "Personal Savings",
    bankAccountTitle: "Li Mei",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Wangfujing Sub-branch",
    branchCode: "WFJ-012",
    branchNumber: "012",
    ifscNumber: "-",
    swiftCode: "ICBKCNBJ",
    institutionNumber: "-",
  },
  {
    userId: "USR-023",
    userName: "Emily Nguyen",
    beneficiaryId: "BNF-6618",
    beneficiaryName: "Tran Van Hung",
    receiverType: "Individual",
    receivingMethod: "Cash pickup",
    phone: "+84 90 123 4567",
    createdTime: "09/03/2026 16:48:33",
    country: "Vietnam",
    currency: "Vietnamese Dong",
    relationship: "Family",
    idType: "National ID",
    idNumber: "079201012345",
    idExpiryDate: "22/08/2027",
    dob: "15/06/1995",
    firstName: "Van Hung",
    middleName: "-",
    lastName: "Tran",
    middleInitial: "T",
    jointAccountHolder: "-",
    taxId: "-",
    companyReg: "-",
    nativeName: "Trần Văn Hùng",
    contactNumber: "+84 90 123 4567",
    address: "12 Nguyen Hue Boulevard",
    city: "Ho Chi Minh City",
    state: "Ho Chi Minh",
    postalCode: "700000",
    suburb: "District 1",
    bank: "Vietcombank",
    cashPickupLocation: "Western Union - Nguyen Hue",
    iban: "-",
    accountNumber: "0071001234567",
    accountType: "Personal",
    bankAccountTitle: "Tran Van Hung",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Ho Chi Minh City Branch",
    branchCode: "HCM-001",
    branchNumber: "001",
    ifscNumber: "-",
    swiftCode: "BFTVVNVX",
    institutionNumber: "-",
  },
  {
    userId: "USR-057",
    userName: "David Kim",
    beneficiaryId: "BNF-9924",
    beneficiaryName: "Seoul Tech Corp",
    receiverType: "Organization",
    receivingMethod: "Bank transfer",
    phone: "+82 10 9876 5432",
    createdTime: "09/03/2026 08:15:20",
    country: "South Korea",
    currency: "South Korean Won",
    relationship: "Business partner",
    idType: "Business License",
    idNumber: "BRN-123-45-67890",
    idExpiryDate: "31/12/2031",
    dob: "20/09/1983",
    firstName: "Seoul",
    middleName: "Tech",
    lastName: "Corp",
    middleInitial: "S",
    jointAccountHolder: "-",
    taxId: "TAX-123-45-67890",
    companyReg: "CR-2019-Seoul-112233",
    nativeName: "서울테크코프",
    contactNumber: "+82 10 9876 5432",
    address: "123 Teheran-ro",
    city: "Seoul",
    state: "Seoul",
    postalCode: "06134",
    suburb: "Gangnam-gu",
    bank: "Kookmin Bank",
    cashPickupLocation: "-",
    iban: "-",
    accountNumber: "123456-04-123456",
    accountType: "Corporate Current",
    bankAccountTitle: "Seoul Tech Corp",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Gangnam Branch",
    branchCode: "GNM-088",
    branchNumber: "088",
    ifscNumber: "-",
    swiftCode: "CZNBKRSE",
    institutionNumber: "-",
  },
  {
    userId: "USR-031",
    userName: "Priya Sharma",
    beneficiaryId: "BNF-4456",
    beneficiaryName: "Rahul Sharma",
    receiverType: "Individual",
    receivingMethod: "Bank transfer",
    phone: "+91 98765 43210",
    createdTime: "08/03/2026 13:37:44",
    country: "India",
    currency: "Indian Rupee",
    relationship: "Family",
    idType: "Aadhaar Card",
    idNumber: "AADH-9876-5432-1098",
    idExpiryDate: "-",
    dob: "29/01/1993",
    firstName: "Rahul",
    middleName: "Kumar",
    lastName: "Sharma",
    middleInitial: "R",
    jointAccountHolder: "-",
    taxId: "ABCPS1234D",
    companyReg: "-",
    nativeName: "राहुल शर्मा",
    contactNumber: "+91 98765 43210",
    address: "Plot 45, Sector 18",
    city: "Noida",
    state: "Uttar Pradesh",
    postalCode: "201301",
    suburb: "Sector 18",
    bank: "State Bank of India",
    cashPickupLocation: "-",
    iban: "-",
    accountNumber: "31529876543210",
    accountType: "Personal Savings",
    bankAccountTitle: "Rahul Kumar Sharma",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Noida Sector 18 Branch",
    branchCode: "NOI-018",
    branchNumber: "018",
    ifscNumber: "SBIN0001234",
    swiftCode: "SBININBB",
    institutionNumber: "-",
  },
  {
    userId: "USR-074",
    userName: "Sophie Martin",
    beneficiaryId: "BNF-2287",
    beneficiaryName: "Euro Logistics GmbH",
    receiverType: "Organization",
    receivingMethod: "Bank transfer",
    phone: "+49 30 1234 5678",
    createdTime: "08/03/2026 09:52:11",
    country: "Germany",
    currency: "Euro",
    relationship: "Business partner",
    idType: "Business License",
    idNumber: "HRB-123456",
    idExpiryDate: "15/03/2033",
    dob: "03/07/1977",
    firstName: "Euro",
    middleName: "Logistics",
    lastName: "GmbH",
    middleInitial: "E",
    jointAccountHolder: "-",
    taxId: "DE123456789",
    companyReg: "HRB-123456",
    nativeName: "Euro Logistics GmbH",
    contactNumber: "+49 30 1234 5678",
    address: "Unter den Linden 77",
    city: "Berlin",
    state: "Berlin",
    postalCode: "10117",
    suburb: "Mitte",
    bank: "Deutsche Bank",
    cashPickupLocation: "-",
    iban: "DE89 3704 0044 0532 0130 00",
    accountNumber: "0532013000",
    accountType: "Corporate Current",
    bankAccountTitle: "Euro Logistics GmbH",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Berlin Mitte Branch",
    branchCode: "BRL-001",
    branchNumber: "001",
    ifscNumber: "-",
    swiftCode: "DEUTDEDB",
    institutionNumber: "-",
  },
  {
    userId: "USR-006",
    userName: "Michael Torres",
    beneficiaryId: "BNF-1195",
    beneficiaryName: "Juan Torres",
    receiverType: "Individual",
    receivingMethod: "Cash pickup",
    phone: "+1 305 555 0199",
    createdTime: "07/03/2026 17:20:09",
    country: "Mexico",
    currency: "Mexican Peso",
    relationship: "Family",
    idType: "Passport",
    idNumber: "G23456789",
    idExpiryDate: "10/11/2026",
    dob: "14/02/1988",
    firstName: "Juan",
    middleName: "Carlos",
    lastName: "Torres",
    middleInitial: "J",
    jointAccountHolder: "-",
    taxId: "-",
    companyReg: "-",
    nativeName: "Juan Carlos Torres",
    contactNumber: "+52 55 1234 5678",
    address: "Av. Insurgentes Sur 1234",
    city: "Mexico City",
    state: "CDMX",
    postalCode: "03100",
    suburb: "Benito Juárez",
    bank: "BBVA Mexico",
    cashPickupLocation: "Elektra - Insurgentes Sur",
    iban: "-",
    accountNumber: "012180015600002458",
    accountType: "Personal",
    bankAccountTitle: "Juan Carlos Torres",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Insurgentes Branch",
    branchCode: "INS-055",
    branchNumber: "055",
    ifscNumber: "-",
    swiftCode: "BCMRMXMM",
    institutionNumber: "-",
  },
  {
    userId: "USR-099",
    userName: "Aisha Abdullah",
    beneficiaryId: "BNF-8801",
    beneficiaryName: "Gulf Trading FZE",
    receiverType: "Organization",
    receivingMethod: "Bank transfer",
    phone: "+971 50 123 4567",
    createdTime: "07/03/2026 11:44:30",
    country: "United Arab Emirates",
    currency: "UAE Dirham",
    relationship: "Business partner",
    idType: "Business License",
    idNumber: "DMCC-FZE-12345",
    idExpiryDate: "28/02/2028",
    dob: "05/05/1981",
    firstName: "Gulf",
    middleName: "Trading",
    lastName: "FZE",
    middleInitial: "G",
    jointAccountHolder: "-",
    taxId: "TRN-100234567800003",
    companyReg: "DMCC-12345",
    nativeName: "خليج للتجارة",
    contactNumber: "+971 4 123 4567",
    address: "Jumeirah Lakes Towers, Cluster T",
    city: "Dubai",
    state: "Dubai",
    postalCode: "00000",
    suburb: "JLT",
    bank: "Emirates NBD",
    cashPickupLocation: "-",
    iban: "AE070331234567890123456",
    accountNumber: "1234567890123456",
    accountType: "Corporate Current",
    bankAccountTitle: "Gulf Trading FZE",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "JLT Branch",
    branchCode: "JLT-003",
    branchNumber: "003",
    ifscNumber: "-",
    swiftCode: "EBILAEAD",
    institutionNumber: "-",
  },
  {
    userId: "USR-063",
    userName: "Lena Fischer",
    beneficiaryId: "BNF-3377",
    beneficiaryName: "Anna Kowalski",
    receiverType: "Individual",
    receivingMethod: "Bank transfer",
    phone: "+48 600 123 456",
    createdTime: "06/03/2026 15:10:55",
    country: "Poland",
    currency: "Polish Zloty",
    relationship: "Friend",
    idType: "National ID",
    idNumber: "AZE 123456",
    idExpiryDate: "03/09/2029",
    dob: "22/07/1997",
    firstName: "Anna",
    middleName: "Maria",
    lastName: "Kowalski",
    middleInitial: "A",
    jointAccountHolder: "-",
    taxId: "PESEL-97072212345",
    companyReg: "-",
    nativeName: "Anna Maria Kowalski",
    contactNumber: "+48 600 123 456",
    address: "ul. Marszalkowska 55/3",
    city: "Warsaw",
    state: "Masovian",
    postalCode: "00-050",
    suburb: "Śródmieście",
    bank: "PKO Bank Polski",
    cashPickupLocation: "-",
    iban: "PL27 1140 2004 0000 3002 0135 5387",
    accountNumber: "27114020040000300201355387",
    accountType: "Personal Savings",
    bankAccountTitle: "Anna Maria Kowalski",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Warsaw Central Branch",
    branchCode: "WAW-101",
    branchNumber: "101",
    ifscNumber: "-",
    swiftCode: "BPKOPLPW",
    institutionNumber: "-",
  },
  {
    userId: "USR-011",
    userName: "Ryan Patel",
    beneficiaryId: "BNF-6640",
    beneficiaryName: "NextGen Ventures Pte Ltd",
    receiverType: "Organization",
    receivingMethod: "Bank transfer",
    phone: "+65 9123 4567",
    createdTime: "06/03/2026 10:03:18",
    country: "Singapore",
    currency: "Singapore Dollar",
    relationship: "Business partner",
    idType: "Business License",
    idNumber: "202312345G",
    idExpiryDate: "-",
    dob: "17/04/1980",
    firstName: "NextGen",
    middleName: "Ventures",
    lastName: "Pte Ltd",
    middleInitial: "N",
    jointAccountHolder: "-",
    taxId: "GST-202312345G",
    companyReg: "202312345G",
    nativeName: "NextGen Ventures Pte Ltd",
    contactNumber: "+65 6123 4567",
    address: "1 Raffles Place, #20-01",
    city: "Singapore",
    state: "Singapore",
    postalCode: "048616",
    suburb: "CBD",
    bank: "DBS Bank",
    cashPickupLocation: "-",
    iban: "-",
    accountNumber: "0120123456",
    accountType: "Corporate Current",
    bankAccountTitle: "NextGen Ventures Pte Ltd",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Raffles Place Branch",
    branchCode: "RPL-001",
    branchNumber: "001",
    ifscNumber: "-",
    swiftCode: "DBSSSGSG",
    institutionNumber: "-",
  },
  {
    userId: "USR-050",
    userName: "Natalie Brooks",
    beneficiaryId: "BNF-5512",
    beneficiaryName: "Oliver Brooks",
    receiverType: "Individual",
    receivingMethod: "Bank transfer",
    phone: "+61 412 345 678",
    createdTime: "05/03/2026 14:28:42",
    country: "Australia",
    currency: "Australian Dollar",
    relationship: "Family",
    idType: "Passport",
    idNumber: "PA1234567",
    idExpiryDate: "18/09/2030",
    dob: "30/11/1991",
    firstName: "Oliver",
    middleName: "James",
    lastName: "Brooks",
    middleInitial: "O",
    jointAccountHolder: "-",
    taxId: "TFN-123-456-789",
    companyReg: "-",
    nativeName: "Oliver James Brooks",
    contactNumber: "+61 412 345 678",
    address: "22 Collins Street",
    city: "Melbourne",
    state: "Victoria",
    postalCode: "3000",
    suburb: "CBD",
    bank: "Commonwealth Bank of Australia",
    cashPickupLocation: "-",
    iban: "-",
    accountNumber: "12345678",
    accountType: "Personal Savings",
    bankAccountTitle: "Oliver James Brooks",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "063-000",
    branchName: "Melbourne CBD Branch",
    branchCode: "MEL-001",
    branchNumber: "001",
    ifscNumber: "-",
    swiftCode: "CTBAAU2S",
    institutionNumber: "-",
  },
  {
    userId: "USR-037",
    userName: "Hassan Al-Farsi",
    beneficiaryId: "BNF-7733",
    beneficiaryName: "Fatima Al-Farsi",
    receiverType: "Individual",
    receivingMethod: "Cash pickup",
    phone: "+966 55 123 4567",
    createdTime: "05/03/2026 08:55:27",
    country: "Saudi Arabia",
    currency: "Saudi Riyal",
    relationship: "Family",
    idType: "National ID",
    idNumber: "1098765432",
    idExpiryDate: "10/07/2028",
    dob: "25/12/1994",
    firstName: "Fatima",
    middleName: "Nour",
    lastName: "Al-Farsi",
    middleInitial: "F",
    jointAccountHolder: "-",
    taxId: "-",
    companyReg: "-",
    nativeName: "فاطمة النور الفارسي",
    contactNumber: "+966 55 987 6543",
    address: "King Fahd Road, Building 12",
    city: "Riyadh",
    state: "Riyadh",
    postalCode: "11564",
    suburb: "Al Olaya",
    bank: "Al Rajhi Bank",
    cashPickupLocation: "Al Rajhi Exchange - Olaya Branch",
    iban: "SA44 2000 0001 2345 6789 1234",
    accountNumber: "608010567890",
    accountType: "Personal",
    bankAccountTitle: "Fatima Nour Al-Farsi",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Al Olaya Branch",
    branchCode: "OLY-002",
    branchNumber: "002",
    ifscNumber: "-",
    swiftCode: "RJHISARI",
    institutionNumber: "-",
  },
  {
    userId: "USR-082",
    userName: "Carlos Mendez",
    beneficiaryId: "BNF-4421",
    beneficiaryName: "Grupo Andino S.A.",
    receiverType: "Organization",
    receivingMethod: "Bank transfer",
    phone: "+57 300 123 4567",
    createdTime: "04/03/2026 12:40:15",
    country: "Colombia",
    currency: "Colombian Peso",
    relationship: "Business partner",
    idType: "Business License",
    idNumber: "NIT-900123456-7",
    idExpiryDate: "20/01/2032",
    dob: "09/08/1975",
    firstName: "Grupo",
    middleName: "Andino",
    lastName: "S.A.",
    middleInitial: "G",
    jointAccountHolder: "-",
    taxId: "NIT-900123456-7",
    companyReg: "REG-COL-900123456",
    nativeName: "Grupo Andino S.A.",
    contactNumber: "+57 1 234 5678",
    address: "Carrera 7 No. 71-21, Torre B",
    city: "Bogotá",
    state: "Cundinamarca",
    postalCode: "110231",
    suburb: "Chapinero",
    bank: "Bancolombia",
    cashPickupLocation: "-",
    iban: "-",
    accountNumber: "20900123456",
    accountType: "Corporate Current",
    bankAccountTitle: "Grupo Andino S.A.",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Chapinero Branch",
    branchCode: "CHP-077",
    branchNumber: "077",
    ifscNumber: "-",
    swiftCode: "COLOCOBM",
    institutionNumber: "-",
  },
  {
    userId: "USR-019",
    userName: "Yuki Tanaka",
    beneficiaryId: "BNF-9910",
    beneficiaryName: "Kenji Yamamoto",
    receiverType: "Individual",
    receivingMethod: "Bank transfer",
    phone: "+81 90 1234 5678",
    createdTime: "04/03/2026 07:18:33",
    country: "Japan",
    currency: "Japanese Yen",
    relationship: "Friend",
    idType: "My Number Card",
    idNumber: "MNC-1234-5678-9012",
    idExpiryDate: "05/04/2027",
    dob: "18/10/1996",
    firstName: "Kenji",
    middleName: "-",
    lastName: "Yamamoto",
    middleInitial: "K",
    jointAccountHolder: "-",
    taxId: "-",
    companyReg: "-",
    nativeName: "山本健二",
    contactNumber: "+81 90 1234 5678",
    address: "2-1-1 Shinjuku",
    city: "Tokyo",
    state: "Tokyo",
    postalCode: "160-0022",
    suburb: "Shinjuku",
    bank: "Japan Post Bank",
    cashPickupLocation: "-",
    iban: "-",
    accountNumber: "10190-12345671",
    accountType: "Personal Savings",
    bankAccountTitle: "Yamamoto Kenji",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Shinjuku Branch",
    branchCode: "SNJ-019",
    branchNumber: "019",
    ifscNumber: "-",
    swiftCode: "JPPYJPJT",
    institutionNumber: "-",
  },
  {
    userId: "USR-045",
    userName: "Grace Okonkwo",
    beneficiaryId: "BNF-6655",
    beneficiaryName: "Chidi Okonkwo",
    receiverType: "Individual",
    receivingMethod: "Cash pickup",
    phone: "+234 803 123 4567",
    createdTime: "03/03/2026 16:05:50",
    country: "Nigeria",
    currency: "Nigerian Naira",
    relationship: "Family",
    idType: "National ID",
    idNumber: "NIN-12345678901",
    idExpiryDate: "-",
    dob: "02/04/1999",
    firstName: "Chidi",
    middleName: "Emeka",
    lastName: "Okonkwo",
    middleInitial: "C",
    jointAccountHolder: "-",
    taxId: "-",
    companyReg: "-",
    nativeName: "Chidi Emeka Okonkwo",
    contactNumber: "+234 803 987 6543",
    address: "15 Adeola Odeku Street",
    city: "Lagos",
    state: "Lagos",
    postalCode: "101233",
    suburb: "Victoria Island",
    bank: "Zenith Bank",
    cashPickupLocation: "MoneyGram - Victoria Island",
    iban: "-",
    accountNumber: "2012345678",
    accountType: "Personal",
    bankAccountTitle: "Chidi Emeka Okonkwo",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Victoria Island Branch",
    branchCode: "VI-003",
    branchNumber: "003",
    ifscNumber: "-",
    swiftCode: "ZEIBNGLA",
    institutionNumber: "-",
  },
  {
    userId: "USR-066",
    userName: "Isabella Rossi",
    beneficiaryId: "BNF-2244",
    beneficiaryName: "Marco Bianchi",
    receiverType: "Individual",
    receivingMethod: "Bank transfer",
    phone: "+39 333 123 4567",
    createdTime: "03/03/2026 10:22:07",
    country: "Italy",
    currency: "Euro",
    relationship: "Friend",
    idType: "National ID",
    idNumber: "CA00000AA00A000A",
    idExpiryDate: "27/06/2028",
    dob: "11/09/1987",
    firstName: "Marco",
    middleName: "Antonio",
    lastName: "Bianchi",
    middleInitial: "M",
    jointAccountHolder: "-",
    taxId: "BNCMRC87P11H501Z",
    companyReg: "-",
    nativeName: "Marco Antonio Bianchi",
    contactNumber: "+39 333 987 6543",
    address: "Via Roma 123",
    city: "Rome",
    state: "Lazio",
    postalCode: "00184",
    suburb: "Centro Storico",
    bank: "Intesa Sanpaolo",
    cashPickupLocation: "-",
    iban: "IT60 X054 2811 1010 0000 0123 456",
    accountNumber: "000000123456",
    accountType: "Personal Current",
    bankAccountTitle: "Marco Antonio Bianchi",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Rome Centro Branch",
    branchCode: "ROM-001",
    branchNumber: "001",
    ifscNumber: "-",
    swiftCode: "BCITITMM",
    institutionNumber: "-",
  },
  {
    userId: "USR-093",
    userName: "Benjamin Osei",
    beneficiaryId: "BNF-8813",
    beneficiaryName: "AfriTech Solutions Ltd",
    receiverType: "Organization",
    receivingMethod: "Bank transfer",
    phone: "+233 24 123 4567",
    createdTime: "02/03/2026 13:55:44",
    country: "Ghana",
    currency: "Ghanaian Cedi",
    relationship: "Business partner",
    idType: "Business License",
    idNumber: "GH-BL-2021-00456",
    idExpiryDate: "11/11/2026",
    dob: "14/03/1984",
    firstName: "AfriTech",
    middleName: "Solutions",
    lastName: "Ltd",
    middleInitial: "A",
    jointAccountHolder: "-",
    taxId: "TIN-C0012345678",
    companyReg: "GH-CR-00456",
    nativeName: "AfriTech Solutions Ltd",
    contactNumber: "+233 30 123 4567",
    address: "12 Independence Avenue",
    city: "Accra",
    state: "Greater Accra",
    postalCode: "GA-123-4567",
    suburb: "Central Accra",
    bank: "Ghana Commercial Bank",
    cashPickupLocation: "-",
    iban: "-",
    accountNumber: "1011234567890",
    accountType: "Corporate Current",
    bankAccountTitle: "AfriTech Solutions Ltd",
    transitNumber: "-",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "Independence Avenue Branch",
    branchCode: "IND-001",
    branchNumber: "001",
    ifscNumber: "-",
    swiftCode: "GHCBGHAC",
    institutionNumber: "-",
  },
  {
    userId: "USR-028",
    userName: "Amanda Wilson",
    beneficiaryId: "BNF-1108",
    beneficiaryName: "Thomas Wilson",
    receiverType: "Individual",
    receivingMethod: "Bank transfer",
    phone: "+1 647 555 0182",
    createdTime: "02/03/2026 08:30:19",
    country: "Canada",
    currency: "Canadian Dollar",
    relationship: "Family",
    idType: "Driver's License",
    idNumber: "W1234-56789-00000",
    idExpiryDate: "09/08/2026",
    dob: "06/06/1990",
    firstName: "Thomas",
    middleName: "Edward",
    lastName: "Wilson",
    middleInitial: "T",
    jointAccountHolder: "-",
    taxId: "SIN-123-456-789",
    companyReg: "-",
    nativeName: "Thomas Edward Wilson",
    contactNumber: "+1 647 555 0199",
    address: "100 King Street West",
    city: "Toronto",
    state: "Ontario",
    postalCode: "M5X 1A9",
    suburb: "Financial District",
    bank: "Royal Bank of Canada",
    cashPickupLocation: "-",
    iban: "-",
    accountNumber: "1234567",
    accountType: "Personal Chequing",
    bankAccountTitle: "Thomas Edward Wilson",
    transitNumber: "00123",
    sortCode: "-",
    routingNumber: "-",
    bsbNumber: "-",
    branchName: "King Street West Branch",
    branchCode: "KSW-001",
    branchNumber: "001",
    ifscNumber: "-",
    swiftCode: "ROYCCAT2",
    institutionNumber: "003",
  },
];

export default beneficiariesData;
